import { render, staticRenderFns } from "./Country-list.vue?vue&type=template&id=d49bf88a"
import script from "./Country-list.vue?vue&type=script&lang=js"
export * from "./Country-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports